var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReopenServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#008C15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.566406 16.488281 L 8.164062 16.488281 C 7.535156 16.488281 7.03125 15.980469 7.03125 15.351562 L 7.03125 9.300781 C 7.03125 8.84375 7.304688 8.425781 7.730469 8.25 C 8.15625 8.074219 8.640625 8.171875 8.96875 8.496094 L 10.9375 10.464844 C 15.078125 6.375 21.75 6.386719 25.867188 10.511719 C 30.003906 14.648438 30.003906 21.351562 25.867188 25.488281 C 21.730469 29.628906 15.027344 29.628906 10.886719 25.488281 C 10.296875 24.898438 10.296875 23.9375 10.886719 23.347656 C 11.480469 22.757812 12.4375 22.757812 13.03125 23.347656 C 15.984375 26.304688 20.773438 26.304688 23.730469 23.347656 C 26.683594 20.394531 26.683594 15.601562 23.730469 12.648438 C 20.789062 9.707031 16.039062 9.691406 13.078125 12.601562 L 15.019531 14.550781 C 15.347656 14.875 15.441406 15.363281 15.265625 15.789062 C 15.089844 16.214844 14.675781 16.488281 14.21875 16.488281 Z M 8.566406 16.488281 ",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopenServiceIcon);
export default __webpack_public_path__ + "static/media/ReopenServiceIcon.259e4db6692b47139ccc512bf3ff9369.svg";
export { ForwardRef as ReactComponent };